<template>
  <div class="w-full">
    <div class="mt-8" :style="isPreview ? 'min-height: 600px' : ''">
      <div
        v-if="isPreview || postLocked"
        id="main-post-content"
        :class="[isPreview || postLocked ? 'block' : 'hidden']"
        data-gp-container=""
        data-gp-style=""
      >
        <div v-if="pageContent">
          <div class="hidden md:block">
            <PrevNextButton
              :isPreview="isPreview"
              :preNextOptions="preNextOptions"
              :changePage="changePage"
            />
          </div>
          <div v-html="pageContent"></div>
        </div>
        <div v-else>
          <div
            id="groovemember-content-box"
            data-gp-container=""
            data-gp-dnd=""
            data-gp-style=""
            class="rounded-md shadow border border-grey-300 bg-white px-5 pb-10"
          >
            <div class="pt-5" id="heirarchydiv">
              <ul class="text-sm text-grey-500" id="page_heirarchy"></ul>
            </div>
            <div
              class="pb-2 pt-2 flex justify-between items-center"
              id="currentpagediv"
            >
              <p
                class="text-xl text-grey-800 font-semibold"
                id="current_page_name2"
              ></p>
            </div>
          </div>
          <!-- Comment Added -->
        </div>
      </div>
      <div v-else :class="[postLocked ? 'hidden' : 'block']" class="">
        <div
          v-if="postAccess"
          class="h-full text-center justify-center p-32 text-lg"
        >
          <span class="block">
            <div class="text-pink text-center" style="font-size: 3rem">
              <i class="fa fa-lock"></i>
            </div>
          </span>
          <span class="text-grey-700 text-xl text-center block">
            This Post is Locked. It will be unlocked on :
            <strong>{{ postAccess }}</strong>
          </span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import PrevNextButton from './prev-next-button';
export default {
  name: 'PageContent',
  components: {
    PrevNextButton,
  },
  props: [
    'pageContent',
    'isPreview',
    'preNextOptions',
    'changePage',
    'postAccess',
    'postLocked',
  ],
};
</script>